import { FC } from 'react';
import { Modal, ModalProps } from 'antd';
import { useGoogleConsentPopup } from 'mod/track/GoogleConsent/useGoogleConsentPopup';
import { RootContent } from 'mod/track/GoogleConsent/RootContent';
import { CustomiseContent } from 'mod/track/GoogleConsent/CustomiseContent';
import { HelpLoader, IHelpLoaderProps } from 'mod/help/HelpLoader';
import { useTrans } from 'base/utils/i18n';

type IProps = {
    className?: string;
    privacyLoaderProps?: IHelpLoaderProps;
};

export const GoogleConsentPC: FC<IProps> = props => {
    const { className, privacyLoaderProps } = props;
    const ins = useGoogleConsentPopup();
    const { t } = useTrans();

    const {
        active,
        rootPopupVisible,
        closeRootPopup,
        customisePopupVisible,
        closeCustomisePopup,
        helpPopupVisible,
        closeHelpPopup,
    } = ins;

    const commonPopupProps: ModalProps = {
        className,
        width: 720,
        centered: true,
        footer: false,
        destroyOnClose: true,
    }

    return !active ? null : (
        <>
            <Modal
                {...commonPopupProps}
                title={t('web_consent_root_title')}
                open={rootPopupVisible}
                onCancel={closeRootPopup}
                closable={false}
                maskClosable={false}
            >
                <RootContent {...ins}/>
            </Modal>

            <Modal
                {...commonPopupProps}
                title={t('web_consent_customise_title')}
                open={customisePopupVisible}
                onCancel={closeCustomisePopup}
            >
                <CustomiseContent {...ins}/>
            </Modal>

            <Modal
                {...commonPopupProps}
                title={t('web_consent_privacy_title')}
                open={helpPopupVisible}
                onCancel={closeHelpPopup}
            >
                <HelpLoader code={'privacy-policy'} showTitle={false} {...privacyLoaderProps}/>
            </Modal>
        </>
    )
};
